export default {
  Normal: 'Normal',
  Collect: 'Collect',
  Cascade: 'Cascade',
};
